import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Parses a date value that may be a MySQL datetime string ("2026-04-21 07:40:16")
 * or an ISO string or a Date object. Safari rejects the MySQL space-separated
 * format — this replaces the space with "T" to make it ISO 8601 compliant.
 */
export function parseDbDate(date: Date | string | null | undefined): Date {
  if (!date) return new Date(NaN);
  if (date instanceof Date) return date;
  return new Date(date.replace(" ", "T"));
}
